// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"paragraph_paragraph__gH54w"};